export default "__VITE_ASSET__C5ZEEk5K__"